import React from "react";
import ButtonBase from "./Buttons";

const TopbarActionGroup = ({
  showDashboard = false,
  onDashboard,
  onLogout,
  dashboardLabel = "Dashboard",
  logoutLabel = "Logout",
  className = "",
}) => {
  return (
    <div className={`ui-topbar-actions ${className}`.trim()}>
      {showDashboard ? (
        <ButtonBase
          variant="ghost"
          size="sm"
          className="ui-topbar-action-btn"
          onClick={onDashboard}
        >
          {dashboardLabel}
        </ButtonBase>
      ) : null}

      <ButtonBase
        variant="danger"
        size="sm"
        className="ui-topbar-action-btn"
        onClick={onLogout}
      >
        {logoutLabel}
      </ButtonBase>
    </div>
  );
};

export default TopbarActionGroup;
